// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1Rlbm","list":"BalanceDue_list__27hh_","listRow":"BalanceDue_listRow__2Ngvm","total":"BalanceDue_total__3wduE"};